import { memo } from 'react';
import { Heading, isWeb, SizableText, styled } from 'tamagui';

// note: font scaling is completely disabled for now in app/_layout.tsx
const MAX_FONT_SIZE_MULTIPLIER = 1.1;

const SizableTextWithMaxScaling = isWeb
    ? SizableText
    : memo(
          styled(SizableText, {
              maxFontSizeMultiplier: MAX_FONT_SIZE_MULTIPLIER,
          }),
      );

const HeadingWithMaxScaling = isWeb
    ? Heading
    : memo(
          styled(Heading, {
              maxFontSizeMultiplier: MAX_FONT_SIZE_MULTIPLIER,
          }),
      );

export const BodyLargeRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$5',
        fontWeight: '$1',
    }),
);

export const MonoBodyLargeRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$5',
        fontWeight: '$1',
        fontFamily: '$monoBody',
        letterSpacing: '-0.02em',
    }),
);

export const BodyMediumRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$4',
        fontWeight: '$1',
    }),
);

export const MonoBodyMediumRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$4',
        fontWeight: '$1',
        fontFamily: '$monoBody',
        letterSpacing: '-0.02em',
    }),
);

export const BodySmallRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$3',
        fontWeight: '$1',
    }),
);
export const MonoBodySmallRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$3',
        fontWeight: '$1',
        fontFamily: '$monoBody',
        letterSpacing: '-0.02em',
    }),
);

export const FootnoteRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$2',
        fontWeight: '$1',
    }),
);

export const MonoFootnoteRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$2',
        fontWeight: '$1',
        fontFamily: '$monoBody',
        letterSpacing: '-0.02em',
    }),
);

export const LabelRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$1',
        fontWeight: '$1',
    }),
);

export const MonoLabelRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$1',
        fontWeight: '$1',
        fontFamily: '$monoBody',
        letterSpacing: '-0.02em',
    }),
);

export const SuperscriptRegular = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$0',
        fontWeight: '$1',
    }),
);

export const BodyLargeEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$5',
        fontWeight: '$2',
    }),
);

export const MonoBodyLargeEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$5',
        fontWeight: '$2',
        fontFamily: '$monoBodyEmphasized',
        letterSpacing: '-0.02em',
    }),
);

export const BodyMediumEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$4',
        fontWeight: '$2',
    }),
);

export const MonoBodyMediumEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$4',
        fontWeight: '$2',
        fontFamily: '$monoBodyEmphasized',
        letterSpacing: '-0.02em',
    }),
);

export const BodySmallEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$3',
        fontWeight: '$2',
    }),
);

export const MonoBodySmallEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$3',
        fontWeight: '$2',
        fontFamily: '$monoBodyEmphasized',
        letterSpacing: '-0.02em',
    }),
);

export const FootnoteEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$2',
        fontWeight: '$2',
    }),
);

export const MonoFootnoteEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$2',
        fontWeight: '$2',
        fontFamily: '$monoBodyEmphasized',
        letterSpacing: '-0.02em',
    }),
);

export const LabelEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$1',
        fontWeight: '$2',
    }),
);

export const MonoLabelEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$1',
        fontWeight: '$3',
        fontFamily: '$monoBodyEmphasized',
        letterSpacing: '-0.02em',
    }),
);

export const SuperscriptEmphasized = memo(
    styled(SizableTextWithMaxScaling, {
        size: '$0',
        fontWeight: '$2',
    }),
);

export const H1Regular = memo(
    styled(HeadingWithMaxScaling, {
        size: '$4',
        fontWeight: '$1',
    }),
);

export const H2Regular = memo(
    styled(HeadingWithMaxScaling, {
        size: '$3',
        fontWeight: '$1',
    }),
);

export const H3Regular = memo(
    styled(HeadingWithMaxScaling, {
        fontSize: 28,
        fontWeight: '$1',
    }),
);

export const H5Regular = memo(
    styled(HeadingWithMaxScaling, {
        size: '$2',
        fontWeight: '$1',
    }),
);

export const H6Regular = memo(
    styled(HeadingWithMaxScaling, {
        size: '$1',
        fontWeight: '$1',
    }),
);

export const H1Emphasized = memo(
    styled(HeadingWithMaxScaling, {
        size: '$4',
        fontWeight: '$2',
    }),
);

export const H2Emphasized = memo(
    styled(HeadingWithMaxScaling, {
        size: '$3',
        fontWeight: '$2',
    }),
);

export const H3Emphasized = memo(
    styled(HeadingWithMaxScaling, {
        fontSize: 28,
        fontWeight: '$2',
    }),
);

export const H5Emphasized = memo(
    styled(HeadingWithMaxScaling, {
        size: '$2',
        fontWeight: '$2',
    }),
);

export const H6Emphasized = memo(
    styled(HeadingWithMaxScaling, {
        size: '$1',
        fontWeight: '$2',
    }),
);

export const HeroRegular = memo(
    styled(HeadingWithMaxScaling, {
        size: '$5',
        fontWeight: '$1',
    }),
);

export const HeroEmphasized = memo(
    styled(HeadingWithMaxScaling, {
        size: '$5',
        fontWeight: '$2',
    }),
);
